<template>
  <!-- <img :src="imageUrl" @error="handleError" /> -->
  <img :src="imageUrl" @error="handleError" />
</template>

<script>
export default {
  props: ['url', 'type'],
  data() {
    return {
      defaultImg: {
        weibo: require('../../../assets/Site/ExhibitionBoard/weibo.png'),
        news: require('../../../assets/Site/ExhibitionBoard/news.png'),
        toutiao: require('../../../assets/Site/ExhibitionBoard/toutiao.png'),
        facebook: require('../../../assets/Site/ExhibitionBoard/Facbook.png'),
        twitter: require('../../../assets/Site/ExhibitionBoard/twitter.png'),
        api: require('../../../assets/Site/ExhibitionBoard/API.png'),
        youtube: require('../../../assets/Site/ExhibitionBoard/youtube.png'),
        document: require('../../../assets/Site/ExhibitionBoard/document.png'),
        tg: require('../../../assets/Site/ExhibitionBoard/tg.png'),
        ins: require('../../../assets/Site/ExhibitionBoard/ins.png'),
        vk: require('../../../assets/Site/ExhibitionBoard/vk.png'),
        default: require('../../../assets/Site/ExhibitionBoard/default.png'),
        wechat: require('../../../assets/Site/ExhibitionBoard/wechat.png')
      },
      imageUrl: ''
    }
  },
  created() {
    if (this.url == undefined || this.url == null) {
      this.imageUrl = 'undefined'
    } else {
      this.imageUrl = this.url
    }
  },

  methods: {
    handleError() {
      this.imageUrl = this.defaultImg[this.type]
    }
  }
}
</script>

<style lang="less" scoped>
img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
</style>
